import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CptordersService } from 'src/app/Services/NewVisitNote/cptorders.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { IOrdersFacilityProvider } from 'src/app/models/IOrdersFacilityProvider';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ICityDetails } from 'src/app/models/ICityDetails';
import { MatAutocompleteTrigger, MatTableDataSource } from '@angular/material';
import { ICptOrdersComponent } from 'src/app/models/ICptOrdersComponent';
import { Observable } from 'rxjs-compat';
import { map, startWith } from 'rxjs/operators';


@Component({
  selector: 'app-facility-provider',
  templateUrl: './facility-provider.component.html',
  styleUrls: ['./facility-provider.component.css']
})

export class FacilityProviderComponent implements OnInit {
  @ViewChild('facility', { read: MatAutocompleteTrigger, static: false }) facility: MatAutocompleteTrigger;

  FacilityProviderForm: FormGroup;
  public show: boolean = false;
  public FacilityShow: boolean = false;
  public result: any;
  facilityDetails: IOrdersFacilityProvider;
  orderSelectedRowObj: ICptOrdersComponent;
  constructor(private formBuilder: FormBuilder, public cptservice: CptordersService, private spinner: NgxSpinnerService,
    private toastr: ToastrService, private sharedService: SharedService,
    public dialogRef: MatDialogRef<FacilityProviderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICptOrdersComponent) {
    this.orderSelectedRowObj = this.data;
  }
  displayedColumns: string[] = ['FacilityName', 'FacilityAddress', 'PhoneNumber', 'FaxNumber', 'ProviderName', 'NPI'];
  dataSource = new MatTableDataSource<IOrdersFacilityProvider>();



  ngOnInit() {
    this.FacilityProviderForm = this.formBuilder.group({
      facilityName: [''],
      addressLine1: [''],
      addressLine2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      PhoneNumber: [''],
      faxNumber: [''],
      providerFirstName: [''],
      providerLastName: [''],
      providerNPI: [''],
      facilityNameId: ['']
    });

    this.getFacilityDropdown();
    this.getAllOrdersFacilityProviders();
    this.checkValidation();
  }

  ngAfterViewInit() {

    this.facility.panelClosingActions.subscribe(x => {
      if (this.facility.activeOption) {
        this.FacilityProviderForm.patchValue({
          facilityNameId: this.facility.activeOption.value
        });
      }
    });

  }
  showInfo() {
    this.show = !this.show;

    $("#FirstName").attr('autocomplete', 'off');
    $("#LastName").attr('autocomplete', 'off');

    this.clearFacilityDetails();
    this.clearProviderDetails();
  }

  CancelInfo() {
    this.clearProviderDetails();
    this.show = false
  }

  ShowAddFacility() {

    this.FacilityShow = !this.FacilityShow;
    $("#FirstName").attr('autocomplete', 'disabled');
    $("#LastName").attr('autocomplete', 'disabled');


  }

  CancelFacility() {
    this.clearFacilityDetails();
    this.FacilityShow = false;
    this.lstCityInfo = [];
  }


  public FacilityInfoList: IOrdersFacilityProvider[];
  public ProviderInfoList: IOrdersFacilityProvider[];
  addedphoneno: string = "";
  insertFacilityDetails() {
    ;
    //  this.spinner.show();
    this.facilityDetails = new IOrdersFacilityProvider();

    var facilityNames = this.FacilityProviderForm.value.facilityName;
    var existList = this.FacilityInfoList.filter(x => x.facilityName.toLocaleLowerCase() === facilityNames.toLocaleLowerCase());
    if (existList.length > 0) {
      this.toastr.warning("This Facility Name Already exist.");
      return;
    }

    this.facilityDetails.facilityName = this.FacilityProviderForm.value.facilityName;
    this.facilityDetails.addressLine1 = this.FacilityProviderForm.value.addressLine1;
    this.facilityDetails.addressLine2 = this.FacilityProviderForm.value.addressLine2;
    this.facilityDetails.state = this.FacilityProviderForm.value.state;
    this.facilityDetails.city = this.FacilityProviderForm.value.city;
    this.facilityDetails.zipCode = this.FacilityProviderForm.value.zipCode;
    var faxno = this.FacilityProviderForm.value.faxNumber;
    this.facilityDetails.faxNumber = faxno.slice(0, 3) + "-" + faxno.slice(3, 6) + "-" + faxno.slice(6);;
    this.addedphoneno = this.FacilityProviderForm.value.PhoneNumber;
    this.facilityDetails.phoneNumber = this.addedphoneno.slice(0, 3) + "-" + this.addedphoneno.slice(3, 6) + "-" + this.addedphoneno.slice(6);;
    this.facilityDetails.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();

    if (this.facilityDetails.facilityName != "") {
      this.cptservice.InsertOrdersFacilityInfo(this.facilityDetails).subscribe(
        results => {
          this.result = results;
          this.toastr.success(this.result);
          this.getFacilityDetails();
          this.getFacilityDropdown();
          this.clearFacilityDetails();

          // this.spinner.hide();
          this.FacilityShow = false;
        }
      );
    } else {
      this.toastr.warning("Please Enter Facility Name.");
      return;
    }

  }

  // addDashes(f)
  // {
  //   this.addedphoneno = f.replace(/\D[^\.]/g, "");
  //    f = this.addedphoneno.slice(0,3)+"-"+this.addedphoneno.slice(3,6)+"-"+this.addedphoneno.slice(6);
  //    alert(this.addedphoneno);
  // }
  getFacilityDetails() {
    this.cptservice.getOrdersFacilityInfo().subscribe(
      results => {
        // this.result = results;
        this.FacilityInfoList = results;
      }, (err: any) => console.log(err));
  }

  checkValidation() {
    if (this.FacilityProviderForm.value.providerNPI == '' || this.FacilityProviderForm.value.providerNPI == undefined || this.FacilityProviderForm.value.providerNPI == null || this.FacilityProviderForm.value.facilityNameId == '') {
      return true;
    } else {
      return false;
    }
  }

  insertProviderDetails() {
    this.facilityDetails = new IOrdersFacilityProvider();

    var providerNPINumber = this.FacilityProviderForm.value.providerNPI;
    var existList = this.FacilityProvidersList.filter(x => x.providerNPI === providerNPINumber);
    if (existList.length > 0) {
      this.toastr.warning("This NPI Number Already exist.");
      return;
    }
    this.facilityDetails.facilityId = Number(this.facilityId) //this.FacilityProviderForm.value.facilityNameId;
    this.facilityDetails.providerFirstName = this.FacilityProviderForm.value.providerFirstName;
    this.facilityDetails.providerLastName = this.FacilityProviderForm.value.providerLastName;
    this.facilityDetails.providerNPI = this.FacilityProviderForm.value.providerNPI;
    this.facilityDetails.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();

    if (this.FacilityProviderForm.value.facilityNameId != "") {
      if (this.FacilityProviderForm.value.providerNPI != "") {
        this.cptservice.InsertOrdersProvidersInfo(this.facilityDetails).subscribe(
          results => {
            this.result = results;
            this.toastr.success(this.result);
            this.clearProviderDetails();
            this.getAllOrdersFacilityProviders();
            this.FacilityShow = false;
            this.show = false;
          }
        );
      } else {
        this.toastr.warning("Please Select NPI Number.");
        return;
      }
    } else {
      this.toastr.warning("Please Select Facility Name.");
      return;
    }
  }
  getProviderDetails() {
    this.cptservice.getOrdersProvidersInfo().subscribe(
      results => {
        // this.result = results;
        this.ProviderInfoList = results;
      }, (err: any) => console.log(err));
  }
  getFacilityDropdown() {
    this.cptservice.getOrdersFacilityInfo().subscribe(
      results => {
        // this.result = results;
        this.FacilityInfoList = results.sort((a, b) => a.facilityName.localeCompare(b.facilityName));
        this.facilityfilter();
      }, (err: any) => console.log(err));
  }
  clearFacilityDetails() {
    this.FacilityProviderForm.patchValue({
      facilityName: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      PhoneNumber: '',
      faxNumber: '',
    });
  }
  clearProviderDetails() {
    this.FacilityProviderForm.patchValue({
      providerFirstName: '',
      providerLastName: '',
      providerNPI: '',
      facilityNameId: ''
    });
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  // onKeyPress(event: any) {
  //   const keyCode = event.keyCode;
  //   const excludedKeys = [9, 16];
  //   if (!(excludedKeys.includes(keyCode))) {
  //     const zip = event.target.value;
  //     if (zip.length == 5) {
  //       this.getZipCodeInfo(zip);
  //     }
  //     else {
  //       this.getZipCodeInfo(null);
  //     }
  //   }
  // }

  // getZipCodeInfo(id: number) {
  //   if (id != null) {
  //     this.sharedService.getZipCodeDetails(id)
  //       .subscribe(
  //         (city: ICityDetails) => {
  //           this.FacilityProviderForm.patchValue({
  //             city: city[0].cityName,
  //             state: city[0].stateName
  //           });
  //         },
  //         (err: any) => console.log(err)
  //       );
  //   }
  //   else {
  //     this.sharedService.getZipCodeDetails(id)
  //       .subscribe(
  //         (city: ICityDetails) => {
  //           this.FacilityProviderForm.patchValue({
  //             city: "",
  //             state: ""
  //           });
  //         },
  //         (err: any) => console.log(err)
  //       );
  //   }
  // }
  AlphanumericwithspecialOnly(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /[a-zA-Z0-9_'#()@/-\s]+/g;
    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }
  onProviderPopUpClose(): void {
    this.dialogRef.close();
  }

  FacilityProvidersList: IOrdersFacilityProvider[] = [];
  getAllOrdersFacilityProviders() {
    this.cptservice.getAllOrdersFacilityProvidersDetails().subscribe(
      data => {
        this.FacilityProvidersList = data;
        this.dataSource.data = this.FacilityProvidersList;
      }, (err: any) => console.log(err));
  }

  selectedRowIndex: number = -1;
  public selectedProviderRowObj: IOrdersFacilityProvider;
  oncellclick(element: IOrdersFacilityProvider) {
    this.selectedRowIndex = element.facilityProviderId;
    this.selectedProviderRowObj = element;
  }
  onProviderRowSelect() {
    this.dialogRef.close(this.selectedProviderRowObj);
  }

  facilityOptions: Observable<IOrdersFacilityProvider[]>;
  public facilityId: string;

  facilityfilter() {

    this.facilityOptions = this.FacilityProviderForm.get('facilityNameId')!.valueChanges.pipe(
      startWith(""),
      map(value => this._facility(value))
    );
  }
  private _facility(value: string): IOrdersFacilityProvider[] {

    const filterValue = value.toString().toLowerCase();
    return this.FacilityInfoList.filter(option => option.facilityName.toLowerCase().indexOf(filterValue) === 0);
  }

  onSelectionChangedFacility(event) {

    // setTimeout(() => {
    //   $(event.target).prev().trigger('focus');
    // }, 100);
    let facilityList = this.FacilityInfoList.filter(x => x.facilityName === event);
    if (facilityList.length != 0) {
      this.facilityId = facilityList[0].facilityId.toString();
    } else {
      this.facilityId = "0";
    }
  }
  onDoubleClick() {


    this.FacilityProviderForm.patchValue({
      facilityNameId: ''
    })
    document.getElementById('FirstName').focus();
    document.getElementById('facilityProId').focus();
  }
  onKeyTabClickFacility(event) {


    var facId = this.FacilityProviderForm.value.facilityNameId
    var txtVal = event.target.value;

    let facilitylst = this.FacilityProvidersList.filter(x => x.facilityName === txtVal);
    if (facilitylst.length == 0) {
      this.FacilityProviderForm.controls.facilityNameId.setValue('');
    }


    this.facilityfilter();

  }


  cityTypeOptions: Observable<ICityDetails[]>;
  public lstCityInfo: ICityDetails[];

  //** City Type Auto Complete Dropdown */
  onKeyPress(event: any) {

    const keyCode = event.keyCode;
    const excludedKeys = [9, 16];
    if (event.keyCode == 40 || event.keyCode == 13) {
    } else {
      if (!(excludedKeys.includes(keyCode))) {
        const zip = event.target.value;
        if (zip.length == 5) {
          this.getZipCodeInfo(zip);
        }
        else {
          this.lstCityInfo = [];
          this.cityTypeFilter();
          // this.getZipCodeInfo(null);
          // this.lstCityInfo = [];
          this.FacilityProviderForm.patchValue({
            city: "",
            state: ""
          });
        }
      }
    }
  }

  cityTypeFilter() {
    this.cityTypeOptions = this.FacilityProviderForm.get('zipCode')!.valueChanges
      .pipe(
        startWith(''),
        map(value => this.postalCode(value))
      );
  }

  private postalCode(name: string): ICityDetails[] {
    const filterValue = name.toString().toLowerCase();
    return this.lstCityInfo.filter(option => option.cityName.toLowerCase().indexOf(filterValue) === 0);
  }
  focusOutZipCode() {
    if (this.FacilityProviderForm.value.zipCode != null && this.FacilityProviderForm.value.zipCode != undefined && this.FacilityProviderForm.value.zipCode != "") {
      if (this.FacilityProviderForm.value.zipCode.length != 5) {
        this.toastr.error('Invalid Zip Code')
        this.FacilityProviderForm.patchValue({
          zipCode: ''
        })
      }
    }
  }
  zipCodevalue: number = 0;
  cityInfoDummyLst: ICityDetails[] = [];
  getZipCodeInfo(id: number) {
    if (id != null) {
      this.zipCodevalue = id;

      this.sharedService.getZipCodeDetailsAutoComplete(id)
        .subscribe(
          (city: ICityDetails[]) => {
            this.lstCityInfo = city;
            this.cityInfoDummyLst = city;
            if (this.lstCityInfo.length == 0) {
              this.toastr.error('Invalid Zip code')
              this.FacilityProviderForm.patchValue({
                zipCode: '',
              })
            }
            if (this.lstCityInfo.length > 1) {
              this.cityTypeFilter()
            } else {
              this.lstCityInfo = [];
              this.FacilityProviderForm.patchValue({
                city: city[0].cityName,
                state: city[0].stateName
              });
            }
          },
          (err: any) => console.log(err)
        );
    }
    else {
      this.sharedService.getZipCodeDetailsAutoComplete(id)
        .subscribe(
          (city: ICityDetails[]) => {
            // this.lstCityInfo = [];
            // this.FacilityProviderForm.patchValue({
            //   city: "",
            //   state: ""
            // });
          },
          (err: any) => console.log(err)
        );
    }
  }
  onTabclick1() {
    ;
    this.sharedService.getZipCodeDetailsAutoComplete(this.zipCodevalue)
      .subscribe(
        (city: ICityDetails[]) => {
          this.lstCityInfo = city;
          if (this.lstCityInfo.length == 0) {

            this.lstCityInfo = [];
            this.FacilityProviderForm.patchValue({
              city: city[0].cityName,
              state: city[0].stateName
            });
          } else {

            if (this.FacilityProviderForm.value.city === "" && this.FacilityProviderForm.value.zipCode != "") {
              setTimeout(() => {
                var divctrl = document.getElementsByName("zipCode");
                divctrl[0].focus();

              }, 100);

            }


          }
        },
        (err: any) => console.log(err)
      );



  }

  chkCityName: string = "";
  onKeyEnterevent(event) {
    ;
    var chkLst: ICityDetails[] = this.cityInfoDummyLst.filter(x => x.cityName.toString() === event.target.value.toString())
    if (chkLst.length != 0 && chkLst != undefined) {
      this.chkCityName = chkLst[0].cityName;
      this.FacilityProviderForm.patchValue({
        city: chkLst[0].cityName,
        state: chkLst[0].stateName,
        zipCode: this.zipCodevalue
      });
    }

  }
  onClickZipCode(event) {

    this.FacilityProviderForm.patchValue({
      city: event.cityName,
      state: event.stateName,
      zipCode: this.zipCodevalue
    });
  }

}
